export const paymentOutputEvent = ['succeeded', 'payment_method_changed', 'payment_failed'] as const;
export type PaymentOutputEvent = (typeof paymentOutputEvent)[number];

export function isPaymentOutputEvent(a: unknown): a is PaymentOutputEvent {
  return paymentOutputEvent.indexOf(a as PaymentOutputEvent) != -1;
}
